import { getConfig } from '../config';

export function isMobile(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }

  return window.innerWidth < getConfig().mobileBreakpoint;
}

export function isTouchDevice(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }

  return 'ontouchstart' in window || navigator.maxTouchPoints > 0;
}
